export default "__VITE_ASSET__D86Dr8oq__$_#navpanes=0__"